import { render } from "./PlayerPointsGamesCardV2.vue?vue&type=template&id=3fd7df56&scoped=true"
import script from "./PlayerPointsGamesCardV2.vue?vue&type=script&lang=js"
export * from "./PlayerPointsGamesCardV2.vue?vue&type=script&lang=js"

import "./PlayerPointsGamesCardV2.vue?vue&type=style&index=0&id=3fd7df56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd7df56"]])

export default __exports__